import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Bank } from '../models/banks';

interface GetBanksResponse {
	banks: Bank[];
	pagination: Pagination;
}

export const onGetBanks = (page = 1) => {
	return axios.get<JsonResponse<GetBanksResponse>>(`${environment.BASE_API_ENDPOINT}/admin/banks`, {
		params: {
			page,
		},
	});
};

export const onGetBank = (bankId: string) => {
	return axios.get<JsonResponse<Bank>>(`${environment.BASE_API_ENDPOINT}/admin/banks/${bankId}`);
};

export const onCreateBank = (bankData: FormData) => {
	return axios.post<JsonResponse<GetBanksResponse>>(`${environment.BASE_API_ENDPOINT}/admin/banks`, bankData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onUpdateBank = (bankId: string, bankData: FormData) => {
	return axios.post<JsonResponse<Bank>>(`${environment.BASE_API_ENDPOINT}/admin/banks/${bankId}`, bankData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onDeleteBank = (bankId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/banks/${bankId}`);
};
